/** Digits only (e.g. bank account number). */
export const sanitizeDigitsOnly = (value, maxLength = 20) =>
  String(value ?? "").replace(/\D/g, "").slice(0, maxLength);

/** Indian mobile: 10 digits, first digit 6–9. */
export const sanitizeIndianMobile = (value) => {
  const numericValue = String(value ?? "").replace(/\D/g, "").slice(0, 10);
  return /^[6-9]\d{0,9}$/.test(numericValue) ? numericValue : "";
};

export const INDIAN_MOBILE_PATTERN = /^[6-9]\d{9}$/;
export const DIGITS_ONLY_PATTERN = /^\d+$/;

export const numericInputProps = {
  type: "tel",
  inputMode: "numeric",
  pattern: "[0-9]*",
  autoComplete: "off",
};
